"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
exports.Separator = core_1.withTheme(styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border-bottom: ", ";\n    "], ["\n        border-bottom: ", ";\n    "])), function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.crypto.defaultBorder;
}));
var templateObject_1;
